import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BranchesComponent } from './branches/branches.component';
import { EditprofileComponent } from './editprofile/editprofile.component';
import { HolidayPageComponent } from './holiday-page/holiday-page.component';
import { LoginComponent } from './login/login.component';
import { MyordersComponent } from './myorders/myorders.component';
import { OnlineOrderComponent } from './online-order/online-order.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';


const routes: Routes = [
  { path: 'online-order', loadChildren: () => import('./online-order/online-order.module').then(m => m.OnlineOrderModule) },
  
  {
    path: '',
    redirectTo: 'online-order/home',
    pathMatch: 'full'
  }
  ,{
    path: '',
    redirectTo: 'online-order/home',
    pathMatch: 'full'
  }
  ,
  {
    path: 'branches',
    component:BranchesComponent,
    pathMatch: 'full'
    
  },
  {
    path: 'editprofile',
    component:EditprofileComponent,
    pathMatch: 'full'
  },
  {
    path: 'myorders',
    component:MyordersComponent,
    pathMatch: 'full'
  }
  ,
  {
    path: 'registration',
    component:UserRegistrationComponent,
    pathMatch: 'full'
    
  },
  {
    path: 'login',
    component:LoginComponent,
    pathMatch: 'full'
    
  },
  {
    path: 'pagenotfound',
    component:PageNotFoundComponent,
    pathMatch: 'full'
    
  },
  {
    path: 'holidaypage',
    component:HolidayPageComponent,
    pathMatch: 'full'
    
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  providers: [ {provide: LocationStrategy, useClass: HashLocationStrategy}],
  exports: [RouterModule]
})
export class AppRoutingModule { }
